import { forwardRef, useMemo } from 'react';
import { shallow } from 'zustand/shallow';

//* Store
import { useDataStore } from '../store';

//* Helpers
import { getContext } from '@/helpers';

export default function withDataContext(ConnectedComponent, properties = []) {
	return forwardRef((props, ref) => {
		const selector = useMemo(
			() => (state) => (properties.length ? getContext(state, properties) : {}),
			[properties]
		);

		const contextProps = useDataStore(selector, shallow);

		return (
			<ConnectedComponent
				ref={ref}
				{...props}
				{...contextProps}
			/>
		);
	});
}
